export var DATE_FORMATS;
(function (DATE_FORMATS) {
    DATE_FORMATS["DAY_ABS"] = "focus-date-time-day";
    DATE_FORMATS["DAY_REL"] = "focus-relative-time-day";
    DATE_FORMATS["SEC_ABS"] = "focus-date-time-second";
    DATE_FORMATS["SEC_REL"] = "focus-relative-time-second";
    DATE_FORMATS["SEC_ABS_DOT"] = "focus-date-time-second-dot";
    DATE_FORMATS["SEC_REL_DOT"] = "focus-relative-time-second-dot";
    DATE_FORMATS["STD_ABS"] = "focus-date-time";
    DATE_FORMATS["STD_REL"] = "focus-relative-time";
    DATE_FORMATS["MIC_ABS"] = "focus-date-time-micro";
    DATE_FORMATS["MIC_REL"] = "focus-relative-time-micro";
})(DATE_FORMATS || (DATE_FORMATS = {}));
export const DATE_RELATIVE_REGEXP_LIST = {
    "focus-relative-time-day": /^(\d{4})\/(\d{2})\/(\d{2})$/,
    "focus-relative-time-second": /^(\d{4})\/(\d{2})\/(\d{2})\-([0-1]\d|[2][0-3])\:([0-5]\d){1,2}\:([0-5]\d){1,2}$/,
    "focus-relative-time": /^(\d{4})\/(\d{2})\/(\d{2})\-([0-1]\d|[2][0-3])\:([0-5]\d){1,2}\:([0-5]\d){1,2}\.(\d{3})$/,
    "focus-relative-time-micro": /^(\d{4})\/(\d{2})\/(\d{2})\-([0-1]\d|[2][0-3])\:([0-5]\d){1,2}\:([0-5]\d){1,2}\.(\d{6})$/,
    "focus-relative-time-second-dot": /^(\d{4})\/(\d{2})\/(\d{2})\-([0-1]\d|[2][0-3])\:([0-5]\d){1,2}\:([0-5]\d){1,2}\.$/,
};
export const TIME_REGEXP_LIST = {
    "focus-time-hm": /^\d{2}:[0-5]\d$/,
    "focus-time-ahm": /^[+-]\d{2}:[0-5]\d$/,
    "focus-time-hms": /^\d{2}:[0-5]\d:[0-5]\d$/,
    "focus-time-ahms": /^[+-]\d{2}:[0-5]\d:[0-5]\d$/,
};
export var TIME_FORMAT;
(function (TIME_FORMAT) {
    TIME_FORMAT["HM"] = "focus-time-hm";
    TIME_FORMAT["HMS"] = "focus-time-hms";
    TIME_FORMAT["AHM"] = "focus-time-ahm";
    TIME_FORMAT["AHMS"] = "focus-time-ahms";
})(TIME_FORMAT || (TIME_FORMAT = {}));
//# sourceMappingURL=interfaces.js.map